import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';

export default {
  methods: {
    toggleSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      this.$root.$refs[reference].open = !this.$root.$refs[reference].open

      this.$root.$refs[reference].$emit('toggle')

      if (this.$root.$refs[reference].open) {
        this.$root.$refs[reference].$emit('open')

        setTimeout(() => {
          this.$root.$refs[reference].$emit('opened')
        }, 500)

        disableBodyScroll(target, {
          reserveScrollBarGap: true,
        })
      } else {
        this.$root.$refs[reference].$emit('close')

        setTimeout(() => {
          this.$root.$refs[reference].$emit('closed')
        }, 500)

        enableBodyScroll(target, {
          reserveScrollBarGap: true
        })
      }
    },
    closeSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      this.$root.$refs[reference].open = false

      this.$root.$refs[reference].$emit('close')

      setTimeout(() => {
        this.$root.$refs[reference].$emit('closed')
      }, 500)

      enableBodyScroll(target, {
        reserveScrollBarGap: true
      })
    },
    openSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      this.$root.$refs[reference].open = true

      this.$root.$refs[reference].$emit('open')

      setTimeout(() => {
        this.$root.$refs[reference].$emit('opened')
      }, 500)

      disableBodyScroll(target, {
        reserveScrollBarGap: true,
      })
    }
  }
}